/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./config/stores";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";

// Solution for the aria-hidden issue
// Function that monitors aria-hidden attributes and removes them from containers with focusable elements
const fixAriaHiddenIssue = () => {
  // Function to check if an element has focusable children
  const hasFocusableChildren = (element) => {
    const focusableSelectors =
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return element.querySelector(focusableSelectors) !== null;
  };

  // Function that handles MutationObserver events
  const handleMutations = (mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "aria-hidden"
      ) {
        const element = mutation.target;
        // If the element has aria-hidden="true" and contains focusable elements
        if (
          element.getAttribute("aria-hidden") === "true" &&
          hasFocusableChildren(element)
        ) {
          // Transfer the attribute to a special data attribute and remove aria-hidden
          element.setAttribute("data-original-aria-hidden", "true");
          element.removeAttribute("aria-hidden");
        }
      }
    });
  };

  // Create MutationObserver to monitor changes in the DOM
  const observer = new MutationObserver(handleMutations);

  // Start monitoring for the entire page
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["aria-hidden"],
    subtree: true,
  });

  // Initial scan for existing aria-hidden attributes
  document.querySelectorAll('[aria-hidden="true"]').forEach((element) => {
    if (hasFocusableChildren(element)) {
      element.setAttribute("data-original-aria-hidden", "true");
      element.removeAttribute("aria-hidden");
    }
  });

  // Special handling for Material-UI DatePicker components
  document.addEventListener(
    "click",
    (event) => {
      // Check if the click is on or inside a component with classes related to DatePicker
      if (
        event.target.closest(
          ".MuiPickersBasePicker-container, .MuiPickersPopper-paper"
        )
      ) {
        // Give Material-UI some time to open the DatePicker
        setTimeout(() => {
          document
            .querySelectorAll('[aria-hidden="true"]')
            .forEach((element) => {
              if (hasFocusableChildren(element)) {
                element.setAttribute("data-original-aria-hidden", "true");
                element.removeAttribute("aria-hidden");
              }
            });
        }, 50);
      }
    },
    true
  );
};

// Call the function after the application loads
window.addEventListener("DOMContentLoaded", fixAriaHiddenIssue);

toast.configure({ autoClose: 4000 });

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
